// extracted by mini-css-extract-plugin
export var typingIndicator = "_pc-0";